var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPensil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.35446 12.8172L4.19538 11.9762L2.02376 9.80462L1.18284 10.6455V11.6343H2.36568V12.8172H3.35446ZM8.18746 4.24158C8.18746 4.10605 8.11969 4.03828 7.98416 4.03828C7.92255 4.03828 7.87019 4.05985 7.82706 4.10297L2.81848 9.11155C2.77536 9.15468 2.7538 9.20704 2.7538 9.26865C2.7538 9.40418 2.82156 9.47195 2.9571 9.47195C3.0187 9.47195 3.07107 9.45039 3.11419 9.40726L8.12277 4.39868C8.1659 4.35556 8.18746 4.30319 8.18746 4.24158ZM7.68845 2.46733L11.5327 6.31155L3.84422 14H0V10.1558L7.68845 2.46733ZM14 3.35446C14 3.68097 13.886 3.9582 13.6581 4.18614L12.1241 5.72013L8.27987 1.87591L9.81386 0.351155C10.0356 0.117052 10.3129 0 10.6455 0C10.9721 0 11.2524 0.117052 11.4865 0.351155L13.6581 2.51353C13.886 2.7538 14 3.0341 14 3.35446Z",
    fill: "#529F45"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPensil);
export default __webpack_public_path__ + "static/media/Pensil.d0c56ab5cad49d3a1dbf9eddc2b17df5.svg";
export { ForwardRef as ReactComponent };